/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	createContainer,
	type HookReturnValue,
	type Action,
	type BoundActions,
	type HookFunction,
	type OverrideContainerComponent,
} from '@atlassian/react-sweet-state';
import { actions } from './actions/index.tsx';
import type { State } from './types.tsx';

export type Actions = typeof actions;
export type UseCreateProjectPermissionType = () => HookReturnValue<State, Actions>;

const Store = createStore<State, Actions>({
	name: 'create-project-permissions',
	initialState: {
		canCreateProject: false,
		shouldDisplayCreateProject: false,
		canCreateClassicProject: false,
		canCreateNextGenProject: false,
		isFetching: false,
		fetchError: null,
		promise: null,
		hasFetchedOnce: false,
		hasSuccessOnce: false,
	},
	actions,
});

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const CreateProjectPermissionContainer: OverrideContainerComponent<Record<any, any>> =
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	createContainer<State, Actions, Record<any, any>>(Store);
export const useCreateProjectPermission: HookFunction<
	State,
	BoundActions<
		State,
		{
			readonly fetchCreateProjectPermission: () => Action<State>;
		}
	>,
	void
> = createHook(Store);

export const useCreateProjectPermissionActions: HookFunction<
	State,
	BoundActions<
		State,
		{
			readonly fetchCreateProjectPermission: () => Action<State>;
		}
	>,
	void
> = createHook(Store, {
	selector: null,
});
